import { createAsyncThunk } from '@reduxjs/toolkit';

import ApplicationProcessApi from 'api/curo/ApplicationProcessApi';
import { ApplicationProcessActionTypes } from 'enums/curo/ApplicationProcessActionTypes';

export const createSaveTermsOfUseAcceptanceThunk = (api: ApplicationProcessApi) =>
  createAsyncThunk(
    ApplicationProcessActionTypes.SaveTermsOfUseAcceptance,
    async ({ applicationId }: { applicationId: string }) => {
      return api.saveTermsOfUseAcceptance(applicationId);
    },
  );
